import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import cookie from 'js-cookie';
import { clearAnalyticsData, clearBookingData, clearProspectData, clearProviderData, clearSessionData, providerActionCreators } from '.';
import * as definitions from '../../definitions/auth';
import { UserStatus } from '../../enums/user';
import { createAction, newUserSignupPlaceholderId } from '../../interfaces';
import authService from '../../services/auth';
import { http } from '../../services/http';
import Bugsnag from '../../utils/bugsnag';
import { CookieName } from '../../utils/constants';
export var authActionCreators = {
  initialLoadComplete: function initialLoadComplete() {
    return createAction(definitions.INITIAL_LOAD_COMPLETE);
  },
  createUserRequest: function createUserRequest(user) {
    return createAction(definitions.CREATE_USER_REQUEST, user);
  },
  createUserSuccess: function createUserSuccess(user) {
    return createAction(definitions.CREATE_USER_SUCCESS, user);
  },
  createUserFail: function createUserFail(error) {
    return createAction(definitions.CREATE_USER_FAIL, error);
  },
  getUserRequest: function getUserRequest(userId) {
    return createAction(definitions.GET_USER_REQUEST, userId);
  },
  getUserSuccess: function getUserSuccess(user) {
    return createAction(definitions.GET_USER_SUCCESS, user);
  },
  getUserFail: function getUserFail(error) {
    return createAction(definitions.GET_USER_FAIL, error);
  },
  finishSignupRequest: function finishSignupRequest() {
    return createAction(definitions.FINISH_SIGNUP_REQUEST);
  },
  finishSignupSuccess: function finishSignupSuccess(user) {
    return createAction(definitions.FINISH_SIGNUP_SUCCESS, user);
  },
  finishSignupFail: function finishSignupFail(error) {
    return createAction(definitions.FINISH_SIGNUP_FAIL, error);
  },
  loginRequest: function loginRequest() {
    return createAction(definitions.LOGIN_REQUEST);
  },
  loginSuccess: function loginSuccess(authToken) {
    return createAction(definitions.LOGIN_SUCCESS, authToken);
  },
  loginFail: function loginFail(error) {
    return createAction(definitions.LOGIN_FAIL, error);
  },
  logoutAction: function logoutAction() {
    return createAction(definitions.LOGOUT);
  },
  clearAuthErrorsAction: function clearAuthErrorsAction() {
    return createAction(definitions.CLEAR_AUTH_ERRORS);
  },
  setAuthInfoAction: function setAuthInfoAction(info) {
    return createAction(definitions.SET_AUTH_INFO, info);
  },
  clearAuthInfoAction: function clearAuthInfoAction() {
    return createAction(definitions.CLEAR_AUTH_INFO);
  },
  userProviderDidChange: function userProviderDidChange(provider) {
    return createAction(definitions.USER_PROVIDER_DID_CHANGE, provider);
  },
  userProviderServiceDidChange: function userProviderServiceDidChange(providerService) {
    return createAction(definitions.USER_PROVIDER_SERVICE_DID_CHANGE, providerService);
  },
  updateUserRequest: function updateUserRequest(id) {
    return createAction(definitions.UPDATE_USER_REQUEST, id);
  },
  updateUserSuccess: function updateUserSuccess(payload) {
    return createAction(definitions.UPDATE_USER_SUCCESS, payload);
  },
  updateUserFail: function updateUserFail(error) {
    return createAction(definitions.UPDATE_USER_FAIL, error);
  },
  updateUserEmailNotificationsRequest: function updateUserEmailNotificationsRequest(id) {
    return createAction(definitions.UPDATE_USER_EMAIL_NOTIFICATIONS_REQUEST, id);
  },
  updateUserEmailNotificationsSuccess: function updateUserEmailNotificationsSuccess() {
    return createAction(definitions.UPDATE_USER_EMAIL_NOTIFICATIONS_SUCCESS);
  },
  updateUserEmailNotificationsFail: function updateUserEmailNotificationsFail(error) {
    return createAction(definitions.UPDATE_USER_EMAIL_NOTIFICATIONS_FAIL, error);
  },
  requestLoginRequest: function requestLoginRequest() {
    return createAction(definitions.REQUEST_LOGIN_REQUEST);
  },
  requestLoginSuccess: function requestLoginSuccess(email) {
    return createAction(definitions.REQUEST_LOGIN_SUCCESS, email);
  },
  requestLoginFail: function requestLoginFail(error) {
    return createAction(definitions.REQUEST_LOGIN_FAIL, error);
  },
  signupRequest: function signupRequest() {
    return createAction(definitions.SIGNUP_REQUEST);
  },
  signupSuccess: function signupSuccess(payload) {
    return createAction(definitions.SIGNUP_SUCCESS, payload);
  },
  signupFail: function signupFail(error) {
    return createAction(definitions.SIGNUP_FAIL, error);
  },
  updateUserEmailOptionsRequest: function updateUserEmailOptionsRequest(token) {
    return createAction(definitions.UPDATE_USER_EMAIL_OPTIONS_REQUEST, token);
  },
  updateUserEmailOptionsSuccess: function updateUserEmailOptionsSuccess() {
    return createAction(definitions.UPDATE_USER_EMAIL_OPTIONS_SUCCESS);
  },
  updateUserEmailOptionsFail: function updateUserEmailOptionsFail(error) {
    return createAction(definitions.UPDATE_USER_EMAIL_OPTIONS_FAIL, error);
  },
  updateUserPasswordRequest: function updateUserPasswordRequest(id) {
    return createAction(definitions.UPDATE_USER_PASSWORD_REQUEST, id);
  },
  updateUserPasswordSuccess: function updateUserPasswordSuccess() {
    return createAction(definitions.UPDATE_USER_PASSWORD_SUCCESS);
  },
  updateUserPasswordFail: function updateUserPasswordFail(error) {
    return createAction(definitions.UPDATE_USER_PASSWORD_FAIL, error);
  },
  getUserConsentRequest: function getUserConsentRequest() {
    return createAction(definitions.GET_USER_CONSENT_REQUEST);
  },
  getUserConsentSuccess: function getUserConsentSuccess(payload) {
    return createAction(definitions.GET_USER_CONSENT_SUCCESS, payload);
  },
  getUserConsentFail: function getUserConsentFail(error) {
    return createAction(definitions.GET_USER_CONSENT_FAIL, error);
  }
};
export var initialLoadComplete = function initialLoadComplete() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch(authActionCreators.initialLoadComplete()));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var createUser = function createUser(payload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var createUserRequest, createUserSuccess, createUserFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              createUserRequest = authActionCreators.createUserRequest, createUserSuccess = authActionCreators.createUserSuccess, createUserFail = authActionCreators.createUserFail;
              dispatch(createUserRequest(payload));
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                authService.createUser(payload).then(function (user) {
                  dispatch(createUserSuccess(user));
                  resolve(user);
                }, function (error) {
                  dispatch(createUserFail(error));
                  reject(error === null || error === void 0 ? void 0 : error.message);
                });
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var updateUser = function updateUser(id, payload) {
  var showFeedback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var updateUserRequest, updateUserSuccess, updateUserFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              updateUserRequest = authActionCreators.updateUserRequest, updateUserSuccess = authActionCreators.updateUserSuccess, updateUserFail = authActionCreators.updateUserFail;
              dispatch(updateUserRequest(id));
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                authService.updateUser(id, payload).then(function (user) {
                  var refreshToken = cookie.get(CookieName.REFRESH_TOKEN);

                  var work = function work() {
                    var successPayload = {
                      user: user,
                      showFeedback: showFeedback
                    };
                    dispatch(updateUserSuccess(successPayload));
                    resolve(user);
                  }; // the update user succeeded, so always update the user in redux


                  // the update user succeeded, so always update the user in redux
                  http.getNewAccessToken(refreshToken).then(work, work);
                }, function (error) {
                  dispatch(updateUserFail(error));
                  reject(error === null || error === void 0 ? void 0 : error.message);
                });
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var updateUserEmailNotifications = function updateUserEmailNotifications(userId, payload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var updateUserEmailNotificationsRequest, updateUserEmailNotificationsSuccess, updateUserEmailNotificationsFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              updateUserEmailNotificationsRequest = authActionCreators.updateUserEmailNotificationsRequest, updateUserEmailNotificationsSuccess = authActionCreators.updateUserEmailNotificationsSuccess, updateUserEmailNotificationsFail = authActionCreators.updateUserEmailNotificationsFail;
              dispatch(updateUserEmailNotificationsRequest(userId));
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                authService.updateUserEmailNotifications(userId, payload).then(function () {
                  dispatch(updateUserEmailNotificationsSuccess());
                  resolve();
                }, function (error) {
                  dispatch(updateUserEmailNotificationsFail(error));
                  reject(error === null || error === void 0 ? void 0 : error.message);
                });
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var updateUserEmailOptions = function updateUserEmailOptions(token, payload) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var updateUserEmailOptionsRequest, updateUserEmailOptionsSuccess, updateUserEmailOptionsFail;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              updateUserEmailOptionsRequest = authActionCreators.updateUserEmailOptionsRequest, updateUserEmailOptionsSuccess = authActionCreators.updateUserEmailOptionsSuccess, updateUserEmailOptionsFail = authActionCreators.updateUserEmailOptionsFail;
              dispatch(updateUserEmailOptionsRequest(token));
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                authService.updateUserEmailOptions(token, payload).then(function () {
                  dispatch(updateUserEmailOptionsSuccess());
                  resolve();
                }, function (error) {
                  dispatch(updateUserEmailOptionsFail(error));
                  reject(error);
                });
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var updateUserPassword = function updateUserPassword(id, payload) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var updateUserPasswordRequest, updateUserPasswordSuccess, updateUserPasswordFail;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              updateUserPasswordRequest = authActionCreators.updateUserPasswordRequest, updateUserPasswordSuccess = authActionCreators.updateUserPasswordSuccess, updateUserPasswordFail = authActionCreators.updateUserPasswordFail;
              dispatch(updateUserPasswordRequest(id));
              return _context6.abrupt("return", new Promise(function (resolve, reject) {
                authService.updateUserPassword(id, payload).then(function () {
                  dispatch(updateUserPasswordSuccess());
                  resolve(null);
                }, function (error) {
                  dispatch(updateUserPasswordFail(error));
                  reject(error === null || error === void 0 ? void 0 : error.message);
                });
              }));

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var finishSignup = function finishSignup(payload) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var finishSignupRequest, finishSignupSuccess, finishSignupFail;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              finishSignupRequest = authActionCreators.finishSignupRequest, finishSignupSuccess = authActionCreators.finishSignupSuccess, finishSignupFail = authActionCreators.finishSignupFail;
              dispatch(finishSignupRequest());
              return _context7.abrupt("return", authService.finishSignup(payload).then(function (user) {
                dispatch(finishSignupSuccess(user));
                return user;
              }, function (error) {
                dispatch(finishSignupFail(error));
              }));

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var getLoggedInUser = function getLoggedInUser() {
  return function (dispatch) {
    var getUserRequest = authActionCreators.getUserRequest,
        getUserSuccess = authActionCreators.getUserSuccess,
        getUserFail = authActionCreators.getUserFail;
    dispatch(getUserRequest(''));
    return authService.whoAmI().then(function (user) {
      var _user$provider, _user$provider2;

      // GDPR: we don't report email / name
      Bugsnag.setUser(user.id // user.email,
      // `${user.firstName} ${user.lastName}`,
      );
      Bugsnag.addMetadata('userMetadata', {
        providerId: ((_user$provider = user.provider) === null || _user$provider === void 0 ? void 0 : _user$provider.id) || 'null',
        providerServiceIds: (_user$provider2 = user.provider) !== null && _user$provider2 !== void 0 && _user$provider2.services ? user.provider.services.join(',') : 'null'
      });

      if (user.provider) {
        var provider = _objectSpread(_objectSpread({}, user.provider), {}, {
          user: user
        });

        dispatch(providerActionCreators.loggedInProviderSuccess(_objectSpread({}, provider)));
      }

      dispatch(getUserSuccess(_objectSpread(_objectSpread({}, user), {}, {
        limited: user.status === UserStatus.PAST_DUE
      })));
    }, function (error) {
      dispatch(getUserFail(error.statusText)); // Session Expired

      if (error.status === 401) {
        dispatch(logout());
      }
    });
  };
};
export var login = function login(payload) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      var loginRequest, loginSuccess, loginFail;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              loginRequest = authActionCreators.loginRequest, loginSuccess = authActionCreators.loginSuccess, loginFail = authActionCreators.loginFail;
              dispatch(loginRequest());
              return _context8.abrupt("return", authService.login(payload).then(function (auth) {
                if (auth.user.provider) {
                  var provider = _objectSpread(_objectSpread({}, auth.user.provider), {}, {
                    user: auth.user
                  });

                  dispatch(providerActionCreators.loggedInProviderSuccess(_objectSpread({}, provider)));
                }

                dispatch(loginSuccess(auth));
                return auth;
              }, function (error) {
                var _error$data, _error$data2;

                var erroMsg = (error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : _error$data.message) || (error === null || error === void 0 ? void 0 : error.message);

                if ((error === null || error === void 0 ? void 0 : error.status) === 0 && error.readyState === 4) {
                  erroMsg = 'Unable to contact server';
                }

                if ((error === null || error === void 0 ? void 0 : (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.statusCode) === 404) {
                  erroMsg = 'Account not found';
                }

                dispatch(loginFail(erroMsg));
              }));

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var signup = function signup(payload) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var signupRequest, signupSuccess, signupFail;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              signupRequest = authActionCreators.signupRequest, signupSuccess = authActionCreators.signupSuccess, signupFail = authActionCreators.signupFail;
              dispatch(signupRequest());
              return _context9.abrupt("return", authService.signup(payload).then(function () {
                var userInfo = _objectSpread({
                  id: newUserSignupPlaceholderId
                }, payload);

                dispatch(signupSuccess(userInfo));
                return userInfo;
              }, function (error) {
                var _error$data3;

                dispatch(signupFail(error === null || error === void 0 ? void 0 : (_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : _error$data3.message));
              }));

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var requestLogin = function requestLogin(payload) {
  var showErrorOnFailure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch) {
      var requestLoginRequest, requestLoginSuccess, error;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              requestLoginRequest = authActionCreators.requestLoginRequest, requestLoginSuccess = authActionCreators.requestLoginSuccess;
              dispatch(requestLoginRequest());
              _context10.next = 4;
              return authService.requestLogin(payload)["catch"](function (e) {
                error = e;
              });

            case 4:
              if (error) {
                _context10.next = 7;
                break;
              }

              dispatch(requestLoginSuccess(payload.email));
              return _context10.abrupt("return");

            case 7:
              _context10.next = 9;
              return handleRequestLoginError(payload, error, dispatch, showErrorOnFailure);

            case 9:
              return _context10.abrupt("return", _context10.sent);

            case 10:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};

var handleRequestLoginError = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload, error, dispatch, showErrorOnFailure) {
    var _error$data4;

    var requestLoginFail, requestLoginSuccess, erroMsg, V2API, V2APIKEY, res, v2Response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            requestLoginFail = authActionCreators.requestLoginFail, requestLoginSuccess = authActionCreators.requestLoginSuccess;
            erroMsg = error === null || error === void 0 ? void 0 : (_error$data4 = error.data) === null || _error$data4 === void 0 ? void 0 : _error$data4.message;
            V2API = process.env.NEXT_PUBLIC_V2API_URL;
            V2APIKEY = process.env.NEXT_PUBLIC_V2API_KEY;

            if (!((error === null || error === void 0 ? void 0 : error.status) === 401 && V2API && V2APIKEY)) {
              _context11.next = 15;
              break;
            }

            _context11.next = 7;
            return fetch("".concat(V2API, "/auth/login-email"), {
              method: 'POST',
              headers: {
                'x-api-key': V2APIKEY,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                data: {
                  email: payload.email
                }
              })
            })["catch"](function () {
              return void 0;
            });

          case 7:
            res = _context11.sent;

            if (!(res !== null && res !== void 0 && res.ok)) {
              _context11.next = 15;
              break;
            }

            _context11.next = 11;
            return res.json();

          case 11:
            v2Response = _context11.sent;

            if (!((v2Response === null || v2Response === void 0 ? void 0 : v2Response.status) === 'success')) {
              _context11.next = 15;
              break;
            }

            // just have v2 send them the login email and consider it a normal success
            dispatch(requestLoginSuccess(payload.email));
            return _context11.abrupt("return");

          case 15:
            if ((error === null || error === void 0 ? void 0 : error.status) === 0 && error.readyState === 4) {
              erroMsg = 'Unable to contact server';
            }

            if ((error === null || error === void 0 ? void 0 : error.status) === 401 && !showErrorOnFailure) {
              erroMsg = '';
            }

            dispatch(requestLoginFail(erroMsg));
            return _context11.abrupt("return", error);

          case 19:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function handleRequestLoginError(_x11, _x12, _x13, _x14) {
    return _ref11.apply(this, arguments);
  };
}();

export var loginWithToken = function loginWithToken(token) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dispatch) {
      var loginRequest, loginSuccess, loginFail;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              loginRequest = authActionCreators.loginRequest, loginSuccess = authActionCreators.loginSuccess, loginFail = authActionCreators.loginFail;
              dispatch(loginRequest());
              return _context12.abrupt("return", authService.loginWithToken(token).then(function (auth) {
                if (auth.user.provider) {
                  var provider = _objectSpread(_objectSpread({}, auth.user.provider), {}, {
                    user: auth.user
                  });

                  dispatch(providerActionCreators.loggedInProviderSuccess(_objectSpread({}, provider)));
                }

                dispatch(loginSuccess(auth));
                return auth;
              }, function (error) {
                var _error$data5, _error$data6;

                var erroMsg = error === null || error === void 0 ? void 0 : (_error$data5 = error.data) === null || _error$data5 === void 0 ? void 0 : _error$data5.message;

                if ((error === null || error === void 0 ? void 0 : error.status) === 0 && error.readyState === 4) {
                  erroMsg = 'Unable to contact server';
                }

                if ((error === null || error === void 0 ? void 0 : (_error$data6 = error.data) === null || _error$data6 === void 0 ? void 0 : _error$data6.statusCode) === 404) {
                  erroMsg = 'Account not found';
                }

                dispatch(loginFail(erroMsg));
                return error;
              }));

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x15) {
      return _ref12.apply(this, arguments);
    };
  }();
};
export var getUserConsent = function getUserConsent(id) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(dispatch) {
      var getUserConsentRequest, getUserConsentSuccess, getUserConsentFail;
      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              getUserConsentRequest = authActionCreators.getUserConsentRequest, getUserConsentSuccess = authActionCreators.getUserConsentSuccess, getUserConsentFail = authActionCreators.getUserConsentFail;
              dispatch(getUserConsentRequest());
              return _context13.abrupt("return", authService.getUserConsent(id).then(function (payload) {
                dispatch(getUserConsentSuccess(payload));
              }, function (error) {
                var _error$data7, _error$data8;

                var erroMsg = error === null || error === void 0 ? void 0 : (_error$data7 = error.data) === null || _error$data7 === void 0 ? void 0 : _error$data7.message;

                if ((error === null || error === void 0 ? void 0 : error.status) === 0 && error.readyState === 4) {
                  erroMsg = 'Unable to contact server';
                }

                if ((error === null || error === void 0 ? void 0 : (_error$data8 = error.data) === null || _error$data8 === void 0 ? void 0 : _error$data8.statusCode) === 404) {
                  erroMsg = 'Account not found';
                }

                getUserConsentFail(erroMsg);
              }));

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    return function (_x16) {
      return _ref13.apply(this, arguments);
    };
  }();
};
export var logout = function logout() {
  return function (dispatch) {
    var logoutAction = authActionCreators.logoutAction;
    dispatch(logoutAction());
    dispatch(clearAnalyticsData());
    dispatch(clearBookingData());
    dispatch(clearProspectData());
    dispatch(clearProviderData());
    dispatch(clearSessionData());
    localStorage.removeItem(CookieName.ACCESS_TOKEN);
    localStorage.removeItem(CookieName.REFRESH_TOKEN);
    http.removeAuthToken();
  };
};
export var clearAuthErrors = function clearAuthErrors() {
  return function (dispatch) {
    var clearAuthErrorsAction = authActionCreators.clearAuthErrorsAction;
    dispatch(clearAuthErrorsAction());
  };
};
export var setAuthInfo = function setAuthInfo(info) {
  return function (dispatch) {
    var setAuthInfoAction = authActionCreators.setAuthInfoAction;
    dispatch(setAuthInfoAction(info));
  };
};
export var clearAuthInfo = function clearAuthInfo() {
  return function (dispatch) {
    var clearAuthInfoAction = authActionCreators.clearAuthInfoAction;
    dispatch(clearAuthInfoAction());
  };
};